import useAuthStore from '../store/auth';

export function useMenuSelect() {
  const setMenuSelect = useAuthStore(state => state.setMenuSelected);

  const getUrlToSetMenu = () => {
    if (
      window.location.href.includes('reunioes') ||
      window.location.href.includes('base-conhecimento') ||
      window.location.href.includes('assinaturas') ||
      window.location.href.includes('boards') ||
      window.location.href.includes('gestao-usuarios') ||
      // window.location.href.includes('anotacoes') ||
      window.location.href.includes('notificacoes')
    ) {
      setMenuSelect('portal');
    }
    if (window.location.href.includes('contas')) {
      setMenuSelect('account');
    }
    if (window.location.href.includes('logs')) {
      setMenuSelect('logs');
    }
    if (window.location.href.includes('dados-pessoais')) {
      setMenuSelect('profile');
    }
  };

  return { getUrlToSetMenu };
}
